module.exports = __webpack_public_path__ + "static/img/contentLeftImg3.2f62d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentLeftImg3.png
// module id = oByb
// module chunks = 2